import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledWholesaleDelivery = styled.div`
  .delivery-button {
    margin-bottom: 16px;
    background: ${({ theme }) => theme.wholesale};
    border: none;
    box-shadow: none;

    &:hover {
      background: ${({ theme }) => theme.wholesale};
      border: 1px solid ${({ theme }) => theme.wholesale};
    }

    &.delivery-configured {
      background: transparent;
      border: 1px solid ${({ theme }) => theme.wholesale};
      color: ${({ theme }) => theme.black};

      &:hover {
        background-color: ${({ theme }) => theme.wholesale};
        border-color: ${({ theme }) => theme.wholesale};
        color: ${({ theme }) => theme.white};
      }

      @media only screen and (max-width: ${breakpoints.sm}px) {
        background-color: ${({ theme }) => theme.wholesale};
        border-color: ${({ theme }) => theme.wholesale};
        color: ${({ theme }) => theme.white};
      }
    }

    @media only screen and (max-width: ${breakpoints.sm}px) {
      margin-bottom: 0;

      .anticon,
      .ant-btn-icon {
        display: none;
      }
    }
  }

  .delivery-summary {
    background: ${({ theme }) => theme.gray01};
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 16px;

    .delivery-summary-title {
      font-weight: 600;
      margin-bottom: 8px;
    }

    .delivery-summary-address {
      color: ${({ theme }) => theme.gray07};
    }

    .delivery-summary-dates {
      color: ${({ theme }) => theme.gray06};
      font-size: 12px;
      margin-top: 4px;
    }
  }
`;

export const StyledWholesaleDeliveryDrawer = styled.div`
  .delivery-info-text {
    background: ${({ theme }) => theme.warning01};
    padding: 12px 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    font-size: 14px;
    color: ${({ theme }) => theme.warning06};
    border: 1px solid ${({ theme }) => theme.colorBorder};
  }

  .delivery-mode-selector {
    margin-bottom: 24px;

    .ant-radio-group {
      display: flex;
      flex-direction: column;
      gap: 12px;
    }

    .ant-radio-wrapper {
      padding: 16px;
      border: 1px solid ${({ theme }) => theme.colorBorder};
      border-radius: 4px;
      margin: 0;

      &.ant-radio-wrapper-checked {
        border-color: ${({ theme }) => theme.wholesale};
      }

      .ant-radio-checked .ant-radio-inner {
        border-color: ${({ theme }) => theme.wholesale};
        background-color: ${({ theme }) => theme.wholesale};
      }
    }

    .mode-label {
      font-weight: 500;
    }

    .mode-description {
      color: ${({ theme }) => theme.gray06};
      font-size: 12px;
      margin-top: 4px;
    }
  }

  .delivery-form-section {
    margin-top: 24px;

    .delivery-drawer-create-address {
      .ant-input-outlined {
        border-radius: 5px;
      }
      
      input {
        min-height: 30px;
      }
    }
    
    .ant-input,
    .ant-picker,
    .ant-select-selector {
      border-radius: 4px;
    }

    .ant-picker {
      width: 100%;
    }

    .form-control {
      border-radius: 4px;
    }
  }

  .date-range-row {
    display: flex;
    gap: 16px;

    > .ant-form-item {
      width: calc(50% - 8px);
      flex: 0 0 auto;
    }
  }

  .detailed-delivery-container {
    
    .delivery-drawer-create-address {
      
      .ant-input-outlined {
        border-radius: 5px;
      }

      input {
        min-height: 30px;
      }
    }

    .ant-form-item-control
    .ant-select-selector{
      border-radius: 5px;
      border-color:${({ theme }) => theme.colorBorder};
    }
    
    .add-delivery-btn {
      background-color:${({ theme }) => theme.colorBorder};
      color:${({ theme }) => theme.black2};
      width: 100%;
      margin-top: 16px;
      border:1px solid ${({ theme }) => theme.colorBorder};
      min-height: 63px;
    }
  }
`;

export const StyledWholesaleDeliveryFooter = styled.div`
  padding: 0 16px;

  .footer-button {
    width: 100%;
    min-height: 64px;
    margin-left: -8px;
    border: 1px solid;
  }

  @media only screen and (max-width: ${breakpoints.sm}px) {
    padding: 0 0 120px 15px;
  }
`;

export const StyledDetailedDeliveryCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colorBorder};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  .ant-input,
  .ant-picker,
  .ant-input-number,
  .ant-input-number-group-wrapper .ant-input-number {
    border-radius: 4px;
  }

  .ant-select-selector {
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.gray03};
  }

  .form-control {
    border-radius: 4px;
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .card-title {
      font-weight: 600;
    }

    .card-actions {
      display: flex;
      gap: 8px;
    }
  }

  .date-range-row {
    display: flex;
    gap: 16px;

    > .ant-form-item {
      flex: 1;
      min-width: 0;

      .ant-picker {
        width: 100%;
      }
    }
  }

  .set-period-checkbox {
    margin-bottom: 16px;
  }

  .checkbox-row {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
  }

  .product-list {
    margin-top: 16px;

    .product-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;
      border-bottom: 1px solid ${({ theme }) => theme.gray02};

      &:last-child {
        border-bottom: none;
      }

      .product-name {
        flex: 1;
        display: flex;
        align-items: center;
      }

      .product-quantity {
        display: flex;
        align-items: center;
        margin-bottom: 0;

        .amount-selector {
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid ${({ theme }) => theme.mediumGrey};
          border-radius: 20px;
          min-width: 130px;

          .btn-amount {
            background: none;
            border: none;
            padding: 6px 13px;
            font-weight: 500;
            font-size: 15px;
            cursor: pointer;

            &:hover {
              font-weight: 700;
            }
          }

          .unit-value {
            display: flex;
            gap: 5px;
            align-items: center;

            .ant-input-number {
              border: none;
              box-shadow: none;
              width: 52px;

              input {
                text-align: center;
                padding: 0;
                height: 24px;
              }
            }

            .unit-label {
              font-size: 14px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
`;
